import { ContainerListViewModel } from '@/react/docker/containers/types';

import { DetailsRow } from '@@/DetailsTable/DetailsRow';

interface Props {
  labels: ContainerListViewModel['Labels'] | undefined;
}

export function LabelsRow({ labels = {} }: Props) {
  const labelList = Object.entries(labels);

  if (labelList.length === 0) {
    return null;
  }

  return (
    <DetailsRow label="Labels">
      <table className="table-bordered table-condensed table">
        <tbody>
          {labelList.map(([label, value]) => (
            <tr key={label}>
              <td>{label}</td>
              <td>{value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </DetailsRow>
  );
}
